import React from 'react';

import { AnalyticsKeys, TrackPageLoad } from '@atlassian/ptc-common';

import RecordTransition from '../components/RecordTransition';
import { LazyTeamsDisabled } from '../components/TeamError/lazy';

const SearchTeamsError = () => {
	return (
		<>
			<RecordTransition name={AnalyticsKeys.ALL_TEAMS_DISABLED} />
			<TrackPageLoad name={AnalyticsKeys.ALL_TEAMS_DISABLED} />
			<LazyTeamsDisabled />
		</>
	);
};

export default SearchTeamsError;
